export default __webpack_public_path__ + "static/media/2020_Properties_Assets-08.31935f8e.svg";